
/**
 * Utility functions for optimizing network requests
 */

// Default headers that include compression support
export const optimizedFetchHeaders = {
  'Accept-Encoding': 'gzip, deflate, br',
  'Cache-Control': 'max-age=3600',
};

// Optimized fetch function that requests compressed responses
export const optimizedFetch = async (url: string, options: RequestInit = {}) => {
  const headers = {
    ...optimizedFetchHeaders,
    ...(options.headers || {}),
  };

  return fetch(url, {
    ...options,
    headers,
  });
};

// Helper function to reduce URL redirects by normalizing URLs
export const normalizeUrl = (url: string): string => {
  // Remove trailing slashes to prevent redirects
  return url.replace(/\/+$/, '');
};

// Prefetch critical resources
export const prefetchResources = (urls: string[]) => {
  if (typeof window !== 'undefined') {
    urls.forEach(url => {
      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = url;
      document.head.appendChild(link);
    });
  }
};
